import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-216cf6c2")

_pushScopeId("data-v-216cf6c2")
const _hoisted_1 = { class: " relative inline-block text-12px xxl:text-14px" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "secion-filter-card text-12px absolute right-0 mt-2 bg-white border rounded-md shadow-lg z-50"
}
const _hoisted_5 = { class: "flex justify-between items-center px-4 pt-4 pb-3 border-b" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_7 = { class: "flex justify-between items-center px-4 py-3 border-t" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LastLocationFilterSection = _resolveComponent("LastLocationFilterSection")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["secion-filter flex justify-between items-center border px-3 py-2 xxl:py-2.5 cursor-pointer select-none rounded", 
        _ctx.isOpen || _ctx.activeFilterCount
          ? 'bg-red-lp-50 border-red-lp-200'
          : 'bg-white'
      ],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createVNode("span", {
        class: ["text-12px font-semibold", 
          _ctx.isOpen || _ctx.activeFilterCount ? 'text-red-lp-200' : 'text-gray-lp-300'
        ]
      }, [
        _hoisted_2,
        (_ctx.activeFilterCount)
          ? (_openBlock(), _createBlock("span", _hoisted_3, " (" + _toDisplayString(_ctx.activeFilterCount) + ") ", 1))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_Icons, {
        name: _ctx.isOpen || _ctx.activeFilterCount ? 'chevron-up' : 'chevron-down',
        class: [_ctx.isOpen || _ctx.activeFilterCount ? 'text-red-lp-200' : '', "w-2.5 font-bold"]
      }, null, 8, ["name", "class"])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Icons, {
              name: "chevron-down",
              class: "w-2.5 font-bold text-black"
            })
          ]),
          _createVNode("div", {
            class: [{ 'p-4': _ctx.options.length > 0 }]
          }, [
            _createVNode(_component_LastLocationFilterSection, {
              options: _ctx.options,
              modelValue: _ctx.selectedLastLocations,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedLastLocations = $event)),
              testIdPrefix: "urgent-hal",
              ref: (r) => (_ctx.lastLocationHalRef = r)
            }, null, 8, ["options", "modelValue"])
          ], 2),
          _createVNode("div", _hoisted_7, [
            _createVNode("button", {
              "data-testid": 'urgent-hal-filter-reset',
              class: "text-red-500 text-sm font-medium",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
            }, " Reset "),
            _createVNode("button", {
              "data-testid": 'urgent-hal-filter-apply',
              class: ["text-white text-sm px-9 py-1.5 rounded transition", 
            _ctx.isApplyDisabled
              ? 'bg-gray-lp-600 cursor-not-allowed'
              : 'bg-red-lp-100'
          ],
              disabled: _ctx.isApplyDisabled,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onApply && _ctx.onApply(...args)))
            }, " Terapkan ", 10, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})